// extracted by mini-css-extract-plugin
export default {"container":"CameraSelector_container__2BU3W"};